var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotice = function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Notice_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.827 7.857A6.857 6.857 0 1 0 5.6 13.103a4.839 4.839 0 0 1 1.757 3.025l.043.3h5.142a5.288 5.288 0 0 1 1.809-3.334 6.82 6.82 0 0 0 2.477-5.237Z",
    fill: "url(#Notice_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.411 16.428h5.143v1.286A1.286 1.286 0 0 1 11.27 19H8.67a1.286 1.286 0 0 1-1.285-1.286V16.43h.025Z",
    fill: "url(#Notice_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.829 2.286a.617.617 0 0 0-.489.244.737.737 0 0 1-.523.309 1.286 1.286 0 0 1-.681 1.958 1.286 1.286 0 0 1-1.56-.741.699.699 0 0 1-.356.094.75.75 0 0 1-.279-.056.69.69 0 0 0-.75.137 6.81 6.81 0 0 0-2.035 4.23v.03a6.857 6.857 0 0 0 2.455 4.625 4.8 4.8 0 0 1 1.745 3l.043.313h5.142a5.29 5.29 0 0 1 1.809-3.335 6.823 6.823 0 0 0 2.43-4.624 6.857 6.857 0 0 0-6.951-6.184Z",
    fill: "url(#Notice_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97 13.214a3.219 3.219 0 0 0-2.91 1.852c.144.341.244.7.296 1.067l.043.296h5.142c.066-.453.187-.897.36-1.32a3.223 3.223 0 0 0-2.93-1.895Z",
    fill: "url(#Notice_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813 11.928h.788a.23.23 0 0 0 .217-.148.232.232 0 0 0 .015-.091c-.06-3.065-1.32-3.618-2.863-3.618s-2.803.553-2.863 3.617a.231.231 0 0 0 .232.24h.788a.669.669 0 0 1 .429.142 2.246 2.246 0 0 0 2.828 0 .67.67 0 0 1 .429-.142Z",
    fill: "url(#Notice_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.541 16.428H7.4v.643h5.142v-.643Z",
    fill: "url(#Notice_svg__g)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Notice_svg__b",
    x1: 9.97,
    y1: -3.881,
    x2: 9.97,
    y2: 24.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F39369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Notice_svg__c",
    x1: 9.97,
    y1: 15.516,
    x2: 9.97,
    y2: 27.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Notice_svg__d",
    x1: 330.138,
    y1: -280.595,
    x2: 330.138,
    y2: 693.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F39369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Notice_svg__e",
    x1: 147.371,
    y1: 157.439,
    x2: 147.371,
    y2: 82.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F39369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Notice_svg__f",
    x1: 144.531,
    y1: 140.052,
    x2: 144.531,
    y2: -122.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F39369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Notice_svg__g",
    x1: 89.53,
    y1: 43.698,
    x2: 89.53,
    y2: 37.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Notice_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.126 1)",
    d: "M0 0h13.688v18H0z"
  })))));
};
export default SvgNotice;